import moment from "moment";
import { PureComponent } from "react";

import { DueDate } from "commonComponents/utilities/DueDate/DueDate";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

export interface IColumnDueDateResponse {
    date: string | null;
    linkedScheduleInfo: string | null;
    isPastDue: boolean;
    displayTime: boolean;
}

class ColumnDueDate {
    constructor(data: IColumnDueDateResponse) {
        this.date = data.date ? moment(data.date) : undefined;
        this.isPastDue = data.isPastDue;
        this.linkedScheduleInfo = data.linkedScheduleInfo;
        this.displayTime = data.displayTime;
    }
    date: moment.Moment | undefined;
    linkedScheduleInfo: string | null;
    isPastDue: boolean;
    displayTime: boolean;
}

type CellType = ColumnDueDate | null;

class DueDateCell extends PureComponent<IGridCellRenderProps<CellType>> {
    render() {
        const { cellValue } = this.props;
        if (!cellValue) {
            return null;
        }
        return <DueDate truncateText {...cellValue} />;
    }
}

export const columnDueDate: IClientGridColumn<IColumnDueDateResponse, CellType> = {
    columnType: GridColumnType.dueDate,
    Cell: DueDateCell,
    mapper: (serverCellResponse) =>
        serverCellResponse ? new ColumnDueDate(serverCellResponse) : null,
};
